export default "__VITE_PUBLIC_ASSET__f2470a05__"